import type SVGProps from "~/components/icons/svg-props";

export default function DiscordIcon(props: SVGProps) {
  return (
    <svg
      className={props.className}
      width={props.width}
      height={props.height}
      fill={props.fill}
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.545 17.0915C8.0916 17.7528 7.60602 18.3914 7.09 19.005C3.4 18.9 2 16.505 2 16.505C2.05193 13.1115 2.8743 9.77413 4.405 6.745C5.75009 5.69272 7.38906 5.08466 9.095 5.005L9.595 6.16C10.3092 6.06131 11.0291 6.00953 11.75 6.005C12.4742 6.00744 13.1974 6.05754 13.915 6.155L14.415 5C16.1226 5.08397 17.7617 5.69734 19.105 6.755C20.6308 9.78192 21.4497 13.1156 21.5 16.505C21.5 16.505 20.1 18.9 16.41 19.005C15.9014 18.3946 15.4242 17.7588 14.98 17.1M18.21 15.65C16.29 16.6225 14.4325 17.595 11.75 17.595C9.0675 17.595 7.21 16.6225 5.29 15.65"
        stroke="#210D47" strokeLinecap="round" strokeLinejoin="round"/>
      <path
        d="M8.67354 14.795C9.59861 14.795 10.3485 14.0451 10.3485 13.12C10.3485 12.1949 9.59861 11.445 8.67354 11.445C7.74846 11.445 6.99854 12.1949 6.99854 13.12C6.99854 14.0451 7.74846 14.795 8.67354 14.795Z"
        stroke="#210D47" strokeLinecap="round" strokeLinejoin="round"/>
      <path
        d="M14.8264 14.795C15.7514 14.795 16.5014 14.0451 16.5014 13.12C16.5014 12.1949 15.7514 11.445 14.8264 11.445C13.9013 11.445 13.1514 12.1949 13.1514 13.12C13.1514 14.0451 13.9013 14.795 14.8264 14.795Z"
        stroke="#210D47" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  )
}
